import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";

const VirPhoneInput = ({ phoneNumber, onChange, disabled }) => {
  const classes = useStyles();

  return (
    <>
      <PhoneInput
        value={phoneNumber}
        onChange={onChange}
        preferredCountries={["au", "nz"]}
        placeholder={"+61"}
        country={"au"}
        variant="outlined"
        masks={{ au: ".... ... ..." }}
        className={classes.countryList}
        fullWidth
        disabled={disabled}
        inputStyle={{
          width: "100%",
          height: "56px",
          paddingLeft: "60px",
          fontSize: "16px",
          borderRadius: "4px",
          border: "1px solid #ccc",
        }}
        containerStyle={{
          width: "100%",
          marginTop: "8px",
          marginBottom: "8px",
        }}
        dropdownStyle={{
          borderRadius: "4px",
          border: "1px solid #ccc",
        }}
      />
    </>
  );
};

export default VirPhoneInput;
